import * as Sentry from '@sentry/react';
import { message } from 'antd';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import type { ColdWalletItem, ListColdWalletsResponse } from '@skynet/data-dex-cold-wallets';
import type { SerializedError } from '@reduxjs/toolkit';

/**
 * Normalize the raw cold-wallets list response into {@link ColdWalletItem}s.
 *
 * The OpenAPI spec types `name`, `balances` and `scanUrl` as `object | null`,
 * but at runtime they are strings. This is the single boundary where those
 * fields are coerced to the narrowed shapes the UI relies on.
 */
export const parseWallet = (
  resObj?: ListColdWalletsResponse,
  error?: FetchBaseQueryError | SerializedError,
): ColdWalletItem[] => {
  if (error) {
    return [];
  }

  try {
    return (resObj?.data.list ?? []).map((wallet) => ({
      ...wallet,
      name: typeof wallet.name === 'string' ? wallet.name : null,
      balances: typeof wallet.balances === 'string' ? wallet.balances : null,
      scanUrl: typeof wallet.scanUrl === 'string' ? wallet.scanUrl : null,
    }));
  } catch (error) {
    if (error instanceof Error) {
      message.error(`Error on parse wallet data ${error.message}`);
      Sentry.captureException(new Error('DEX API: wrong wallets list data format'), {
        extra: {
          error: error.message,
          values: resObj,
        },
        level: 'error',
      });
    }
    console.error(error);
  }

  return [];
};
